/*
  Stripe product configuration for client components and server functions.
  Automatically switches between test and production price IDs based on environment.
*/

// Determine if we're in development/test mode
// This file is used by both:
// 1. Frontend (Gatsby) - has access to NODE_ENV and GATSBY_SITEURL
// 2. Backend (Firebase Functions) - has access to FUNCTIONS_EMULATOR
const isTestMode =
  process.env.FUNCTIONS_EMULATOR === 'true' || // Firebase Functions emulator
  process.env.NODE_ENV === 'development' || // Gatsby development mode
  (typeof process.env.GATSBY_SITEURL === 'string' && process.env.GATSBY_SITEURL.includes('localhost')); // Gatsby localhost check

// Test mode price IDs - TODO: Replace with actual test prices from Stripe dashboard
const TEST_MONTHLY_PRICE = 'price_1SMm8TF7W7AgxxZ5d2XDVXSD';
const TEST_YEARLY_PRICE = 'price_1SMm8TF7W7AgxxZ5d2XDVXSD';

// Production price IDs (from your live Stripe dashboard)
const LIVE_MONTHLY_PRICE = 'price_1Rtt18F7W7AgxxZ5VFbO8dRF';
const LIVE_YEARLY_PRICE = 'price_1Rtt18F7W7AgxxZ5DFMdoFLX';

// Select appropriate price IDs based on environment
const monthlyPriceId = isTestMode ? TEST_MONTHLY_PRICE : LIVE_MONTHLY_PRICE;
const yearlyPriceId = isTestMode ? TEST_YEARLY_PRICE : LIVE_YEARLY_PRICE;

module.exports = {
  paddockPass: {
    name: 'Open Racer Paddock Pass',
    price: 9.99,
    yearPrice: 89.99,
    // Stripe recurring price IDs (automatically switches between test/live)
    stripePriceId: monthlyPriceId,
    stripePriceIdYear: yearlyPriceId,
    // Expose mode for debugging
    _isTestMode: isTestMode,
  },
};